import { emitEvent } from "../../AnalyticsTracking/emit-event";
import {
  EVENT_TYPE,
  FORM_ACTION,
  FORM_TYPE,
  FormInteractionEventParameters
} from "../../AnalyticsTracking/events";
import { initializePhoneNumberInput } from "../../Forms/Inputs/PhoneNumberInput/phone-number-input";
import { initializePopovers, removePopover } from "../../Shared/Popover/popover";

(() => {
  document.addEventListener("htmx:beforeOnLoad", () => {
    // Make sure to clear up any existing popovers after POSTing, since all types of POST
    // on this page modifies the existing popover.
    const existingPopover = document.getElementById("actions-popover");

    if (existingPopover) {
      removePopover(existingPopover);
    }
  });
})();

htmx.onLoad(rootElement => {
  const initialize = () => {
    const form = document.getElementById("terms-and-conditions-user-form") as
      HTMLFormElement | undefined;

    if (form) {
      const formId = form.id;
      const formName = document.querySelector("h1")?.textContent?.trim();

      // Form initialization
      const acceptCheckbox = form.querySelector<HTMLInputElement>(
        '[name="FormModel.TermsAndConditionsAccepted"]'
      );

      const submitButton = form.querySelector<HTMLInputElement>('[name="submit"]');

      if (acceptCheckbox && submitButton) {
        acceptCheckbox.onchange = ev => {
          const checkbox = ev.currentTarget as HTMLInputElement;

          if (checkbox.checked) {
            submitButton.disabled = false;
          } else {
            submitButton.disabled = true;
          }
        };
      }

      // Prevent form from being submitted by hitting Enter
      form.addEventListener("keydown", event => {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });

      const inputs = form.querySelectorAll<HTMLInputElement>(
        'input[type="text"], input[type="email"]'
      );

      // Reset input validation errors after modifying them
      // TODO: Create and move to separate input-validation.ts file
      inputs.forEach(
        input =>
          (input.onchange = _ => {
            if (input.classList.contains("input-validation-error")) {
              input.classList.remove("input-validation-error");

              const validationMessage = form.querySelector<HTMLElement>(
                `[data-valmsg-for="${input.name}"]`
              );

              if (validationMessage) {
                validationMessage.innerHTML = "";
              }
            }
          })
      );

      const countryCodeInput = form.querySelector<HTMLInputElement>(
        '[name="FormModel.CountryCode"]'
      );

      const phoneNumberInput = form.querySelector<HTMLInputElement>(
        '[name="FormModel.Phone"]'
      );

      if (countryCodeInput && phoneNumberInput) {
        initializePhoneNumberInput(phoneNumberInput, countryCodeInput);
      }

      // Form ReCaptcha
      // TODO: Extract to separate tag helper
      const reCaptchaInput = form.querySelector<HTMLInputElement>(
        '[name="FormModel.ReCaptchaResponse"]'
      );

      if (reCaptchaInput) {
        const siteKey = reCaptchaInput.dataset.siteKey;

        if (siteKey && typeof grecaptcha !== "undefined") {
          const refreshReCaptcha = async () => {
            const token = await grecaptcha.execute(siteKey, {
              action: "termsandconditions"
            });

            reCaptchaInput.value = token;

            // ReCaptcha has a 2 minute timeout
            setTimeout(refreshReCaptcha, 1000 * 60 * 2 - 5);
          };

          grecaptcha.ready(async () => {
            await refreshReCaptcha();
          });
        }
      }

      // Submit tracking
      htmx.on("htmx:afterRequest", e => {
        const event = e as AfterRequestEvent;

        if (event.detail.xhr.getResponseHeader("Submit-Success") === "true") {
          emitEvent(
            EVENT_TYPE.formInteraction,
            {
              content_type: "content",
              form_action: FORM_ACTION.submit,
              form_id: formId,
              form_name: formName,
              form_type: FORM_TYPE.termsAndConditions
            } satisfies FormInteractionEventParameters,
            true
          );
        }
      });
    }

    initializePopovers(rootElement);
  };

  initialize();
});
